import { createTheme } from "@mui/material/styles"

const primaryMain = "#E83E0A"
const secondaryMain = "#ed1c24"
const darkAccent = "#4D1800"
const textPrimary = "#060606"
const textSecondary = "#646464"

const flameConfig = {
  filterId: "flameWobble",
  filter: {
    baseFrequency: "0.012 0.02",
    baseFrequencyValues: "0.012 0.02;0.02 0.03;0.012 0.02",
    displacementScale: 10,
    displacementScaleValues: "6;12;7;10;6",
    blurStdDeviation: 2,
    glowMatrix: "1 0 0 0 0  0 0.8 0 0 0  0 0 0.2 0 0  0 0 0 0.45 0",
  },
  container: {
    right: { xs: 8, md: 24 },
    top: { xs: -110, sm: -140, md: -140 },
    width: { xs: 150, sm: 200, md: 200 },
    driftDuration: "6s",
  },
  flickerDuration: "1.8s",
  heat: {
    inset: "8%",
    gradient:
      "radial-gradient(circle at 55% 35%, rgba(255,210,120,0.22), rgba(255,120,0,0) 60%)",
    blur: "10px",
    opacity: 0.45,
    shimmerDuration: "2.4s",
    reducedOpacity: 0.35,
  },
  image: {
    shadow: "drop-shadow(0 0 10px rgba(255,140,0,0.4))",
    reducedShadow: "drop-shadow(0 0 8px rgba(255,140,0,0.3))",
  },
  keyframes: {
    drift: {
      "0%": { transform: "translate(0, 0)" },
      "45%": { transform: "translate(-4px, -2px)" },
      "100%": { transform: "translate(0, 0)" },
    },
    flicker: {
      "0%": {
        transform: "translateY(0) rotate(-1deg) scale(1)",
        filter:
          "drop-shadow(0 0 7px rgba(255,140,0,0.38)) brightness(1.01) saturate(1.08)",
      },
      "20%": {
        transform: "translateY(-2px) rotate(2deg) scale(1.03, 0.98)",
        filter:
          "drop-shadow(0 0 9px rgba(255,160,0,0.42)) brightness(1.04) saturate(1.12)",
      },
      "45%": {
        transform: "translateY(-4px) rotate(-2deg) scale(0.98, 1.04)",
        filter:
          "drop-shadow(0 0 10px rgba(255,150,0,0.45)) brightness(1.06) saturate(1.15)",
      },
      "70%": {
        transform: "translateY(-1px) rotate(1deg) scale(1.02, 0.99)",
        filter:
          "drop-shadow(0 0 8px rgba(255,145,0,0.4)) brightness(1.03) saturate(1.1)",
      },
      "100%": {
        transform: "translateY(0) rotate(-1deg) scale(1)",
        filter:
          "drop-shadow(0 0 7px rgba(255,140,0,0.38)) brightness(1.01) saturate(1.08)",
      },
    },
    heat: {
      "0%": { transform: "scale(0.96) translateY(2px)" },
      "50%": { transform: "scale(1.04) translateY(-2px)" },
      "100%": { transform: "scale(0.96) translateY(2px)" },
    },
  },
}

const theme = createTheme({
  custom: {
    flame: flameConfig,
  },
  palette: {
    primary: {
      main: primaryMain,
      light: "#ff7041",
      dark: "#b51600",
      contrastText: "#ffffff",
    },
    secondary: {
      main: secondaryMain,
      light: "#ff5a54",
      dark: darkAccent,
      contrastText: "#ffffff",
    },
    background: {
      default: "#f7f7f7",
      paper: "#ffffff",
    },
    text: {
      primary: textPrimary,
      secondary: textSecondary,
    },
    divider: "#e5e5e5",
  },
  typography: {
    fontFamily: "'Open Sans', 'Inter', system-ui, -apple-system, sans-serif",
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 600,
    h1: {
      fontWeight: 600,
      letterSpacing: "-0.02em",
    },
    h2: {
      fontWeight: 600,
      letterSpacing: "-0.01em",
    },
    button: {
      textTransform: "none",
      fontWeight: 600,
      letterSpacing: "-0.01em",
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiContainer: {
      defaultProps: {
        maxWidth: "lg",
      },
    },
    MuiLink: {
      defaultProps: {
        underline: "hover",
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
        },
      },
    },
  },
})

export default theme
